function getDomain(s) {
  const ym = [
    ".com.cn", ".net.cn", ".org.cn", ".gov.cn", ".com", ".cn", ".ltd", ".net",
    ".tech", ".shop", ".vip", ".xyz", ".中国", ".wang", ".cloud", ".online",
    ".网址", ".我爱你", ".在线", ".餐厅", ".icu", ".site", ".love", ".art",
    ".xin", ".store", ".fun", ".cc", ".website", ".press", ".space", ".beer",
    ".luxe", ".video", ".ren", ".group", ".fit", ".yoga"
    // 其他注释掉的域名后缀可以按需解开
  ];

  const zm = [];
  ym.forEach((d) => {
    zm.push(d.replace(/\./g, "\\."));
  });

  const r = new RegExp("[.]+(" + zm.join("|") + ")");
  const u = s || window.location.hostname;
  const rm = u.match(r);
  return rm ? rm : "";
}
function replaceDomain(s) {
  let a = s || "";
  const h = window.location.href;
  const reg = /(\/\/)([/]+)(\/)?/;

  let am = a.match(reg);
  am = am ? am : null;

  let hm = h.match(reg);
  hm = hm ? hm : null;

  if (am !== hm && s) {
    a = s.replace(reg, function ($0, $1, $2, $3) {
      return $1 + hm + ($3 || "");
    });
  }

  return a;
}

// 导出函数（在浏览器环境中通常不需要，但在模块系统中可能需要）
module.exports = {
  getDomain: getDomain,
  replaceDomain: replaceDomain
};
